import styled from 'styled-components';
import { Link as LinkR } from 'react-router-dom';

export const ThemeContainer = styled.div`
    background: ${({ theme }) => theme.card_light};
    color: ${({ theme }) => theme.primary};
    margin-left: 30px;
    transition:
        background 0.3s ease-in-out,
        color 0.3s ease-in-out;

    @media (max-width: 768px) {
        margin-right: 20px;
    }
`;

export const ThemeLogo = styled(LinkR)`
    color: ${({ theme }) => theme.text_secondary};
    transition: color 0.3s ease-in-out;
`;

export const Elements = styled.div`
    transition: color 0.3s ease-in-out;

    :hover {
        color: ${({ theme }) => theme.primary};
    }
`;
